export var DEPLOY_DATE = new Date('2026-02-25T10:21:53+0000');
